import React, { useEffect, useRef, useState } from "react";
import Typography from "../../../components/Typography/Typography";

import TimeOffDetailsBothModal from "./TimeOffDetailsBothModal";
import CalenderSlider from "../CalenderSlider";
import TimeOffHistoryModal from "../EmployeeTimeOff/TimeOffHistoryModal";
import SingleTimeOffHistoryModal from "../EmployeeTimeOff/SingleTimeOffHistoryModal";
import TeamTimeOffHistoryModal from "./TeamTimeOffHistoryModal";
import { useAppDispatch } from "../../../hooks";
import {
  getTeamLeaveTimeoffAsync,
  getTeamTimeOffsAsync,
} from "../../../services/reducers/leaveReducer";
import RequestTimeOffModal from "../EmployeeTimeOff/RequestTimeOffModal";
import UserImage from "../../../components/UserImage/UserImage";
import getInitialsInName from "../../../helper/GetNameInitials";
import { getDayAndMonth } from "../../../utils/common";
import emptyTimeOffImage from "../../../images/emptyTimeOff.svg";
import UpcomingLeavesModal from "./UpcomingLeavesModal";
import LeaveBalanceEmpty from "../AdminTimeOff/LeaveBalanceEmpty";
import TimeOffCalenderEmpty from "../AdminTimeOff/TimeOffCalenderEmpty";
import ColorLabel from "../ColorLable";

type Props = {
  financialyearList?: any;
  setStartMonthTeam: React.Dispatch<React.SetStateAction<string>>;
  setEndMonthTeam: React.Dispatch<React.SetStateAction<string>>;
  calenderDetail: any;
  role: any;
  activeTab: string;
  setSelectedDate: React.Dispatch<React.SetStateAction<any>>;
  calenderDate: any;
  type: string;
  tab:string;
  setCurrentSlideTeam:React.Dispatch<React.SetStateAction<number>>;
  currentSlideTeam:number;
  setCurrent:React.Dispatch<React.SetStateAction<number>>;
  current:number;
  selectedDate:any;
};

const MyTeamTimeOff: React.FC<Props> = ({
  financialyearList,
  setStartMonthTeam,
  setEndMonthTeam,
  calenderDetail,
  role,
  activeTab,
  setSelectedDate,
  calenderDate,
  type,
  tab,
  setCurrentSlideTeam,
  currentSlideTeam,
  setCurrent,
  current,
  selectedDate
}) => {
  const [timeOffHistory, setTimeOffHistory] = useState<boolean>(false);
  const [timeOffDetailsBoth, setTimeOffDetailsBoth] = useState<boolean>(false);
  const [upcomingLeaves, setUpcomingLeaves] = useState<boolean>(false);
  const [singleTimeOffHistory, setSingleTimeOffHistory] =
    useState<boolean>(false);
  const [teamTimeOffHistory, setTeamTimeOffHistory] = useState<boolean>(false);
  const [rmCreateTimeOff, setRmCreateTimeOff] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [timeSummary, setTimeSummary] = useState<any>([]);
  const [timeoffId, setTimeoffId] = useState("");
  const [timeHistory, setTimeHistory] = useState<any>([]);
  const [searchString, setSearchString] = useState("");
  const [timeoffTab, setTimeoffTab] = useState("");
  const [selectedValue, setSelectedValue] = useState({
    label: "All",
    value: "",
  });
  const activeFinancialYear = financialyearList?.records?.find((record:any) => record.isActive);

  const fyStartDate = activeFinancialYear ? activeFinancialYear.fyStartDate : "";
  const fyEndDate = activeFinancialYear ? activeFinancialYear.fyEndDate : "";
  // const fyStartDate =
  //   financialyearList?.records?.length > 0
  //     ? financialyearList?.records[0]?.fyStartDate
  //     : "";
  // const fyEndDate =
  //   financialyearList?.records?.length > 0
  //     ? financialyearList?.records[0]?.fyEndDate
  //     : "";
  const getMonthName = (monthNumber: number) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[monthNumber - 1];
  };
  const isFetching = useRef(false);

  useEffect(() => {
    if (activeTab === "tab3") {
      getSummary();
      getTimeoffList();
    }
  }, [activeTab]);

  const getSummary = () => {
    if (isFetching.current) return;

    isFetching.current = true;
    const request: any = {
      page: 1,
      pageSize: 50,
      IsEmployee: false,
    };
    dispatch(getTeamLeaveTimeoffAsync(request)).then((res) => {
      if (res.payload) {
        setTimeSummary(res.payload.records);
        isFetching.current = false;
      }
    });
  };

  const handleView = (id: string) => {
    setTimeoffId(id);
    setTimeOffDetailsBoth(true);
  };

  const getTimeoffList = () => {
    // if (isFetching.current) return;

    // isFetching.current = true;
    const request: any = {
      Page: 1,
      PageSize: 100,
      LeaveStatus: "",
      ViewType: "all",
      LeaveId: "",
    };
    dispatch(getTeamTimeOffsAsync(request)).then((res) => {
      if (res.payload) {
        setTimeHistory(res.payload?.records);
        // isFetching.current = false;
      }
    });
  };

  const handleTimeOff = (type: string) => {
    setTimeoffTab(type);
    setUpcomingLeaves(true);
  };
// console.log(calenderDetail, "calenderDetail")
  return (
    <div id="myTeamTimeOff">
      <div
        className="pt-4 ps-10"
        style={{
          background:
            " linear-gradient(90deg, #E2E2E2 61.11%, rgba(255, 255, 255, 0) 99.1%)",
        }}
      >
        <Typography variant="h6" className="text-gray-300 font-bold">
          Leave Applications
        </Typography>
        <div className="overflow-y-hidden">
          <div className="flex justify-start items-start">
            <div className="inline-block h-[120px] w-[120px] p-3 bg-pastel-700 border border-pastel-800 rounded-md mb-8 mt-2.5 cursor-pointer"  onClick={() => setRmCreateTimeOff(true)}>
              <div className="w-full h-full relative">
                <div className="ms-1">
                  <svg
                    width="16"
                    height="22"
                    viewBox="0 0 16 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9908 0.876038H4.51077C0.750771 0.876038 0.46077 4.25604 2.49077 6.09604L13.0108 15.656C15.0408 17.496 14.7508 20.876 10.9908 20.876H4.51077C0.750771 20.876 0.46077 17.496 2.49077 15.656L13.0108 6.09604C15.0408 4.25604 14.7508 0.876038 10.9908 0.876038Z"
                      stroke="#F15845"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <button
                  className="flex justify-between items-center text-400 font-normal text-primary-100 w-full absolute bottom-0 left-0"
                 
                >
                  <span className="inline-block text-left">
                    Create
                    <br />
                    Time Off
                  </span>
                  <span className="inline-block">
                    <svg
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.75839 13.2796C7.91118 13.4459 7.98659 13.6393 7.98659 13.8607C7.98659 14.0821 7.91019 14.2755 7.75839 14.4418C7.60559 14.6082 7.42799 14.6902 7.22459 14.6902C7.0212 14.6902 6.8436 14.6071 6.6908 14.4418C6.538 14.2755 6.4626 14.0821 6.4626 13.8607C6.4626 13.8056 6.4626 13.7505 6.48839 13.6944C6.48839 13.6393 6.51419 13.5842 6.53899 13.528C6.56479 13.4729 6.58959 13.4449 6.61539 13.3898C6.64119 13.3347 6.66599 13.3066 6.71659 13.2796C6.89419 13.0863 7.14818 13.0031 7.40218 13.0582C7.45278 13.0582 7.50338 13.0863 7.55497 13.1133C7.60557 13.1413 7.63137 13.1683 7.68197 13.1964C7.68197 13.1975 7.73358 13.2245 7.75839 13.2796ZM10.4004 9.21516C10.0959 9.54675 10.0959 10.0447 10.4004 10.3763C10.5532 10.5426 10.7308 10.6247 10.9342 10.6247C11.1376 10.6247 11.3152 10.5415 11.468 10.3763C11.7726 10.0447 11.7726 9.54675 11.468 9.21516C11.1872 8.91164 10.705 8.91164 10.4004 9.21516ZM8.54608 11.2339C8.24149 11.5655 8.24149 12.0634 8.54608 12.395C8.69887 12.5614 8.87648 12.6435 9.07987 12.6435C9.28327 12.6435 9.46087 12.5603 9.61367 12.395C9.91826 12.0634 9.91826 11.5655 9.61367 11.2339C9.30809 10.9293 8.85067 10.9293 8.54608 11.2339ZM13.5239 7.61107C13.5239 7.55599 13.4981 7.5009 13.4733 7.44473C13.4475 7.38965 13.4227 7.33456 13.3969 7.30648C13.3711 7.25139 13.3463 7.22331 13.2957 7.16822C13.0159 6.86362 12.5079 6.86362 12.2291 7.16822C12.2033 7.19631 12.1527 7.25139 12.1279 7.30648C12.1021 7.36157 12.0773 7.38965 12.0515 7.44473C12.0257 7.49982 12.0257 7.55491 12.0009 7.61107C12.0009 7.66616 11.9751 7.72124 11.9751 7.77741C11.9751 7.8325 11.9751 7.88758 12.0009 7.94375C12.0009 7.99883 12.0267 8.05392 12.0515 8.11009C12.0773 8.16517 12.1021 8.22026 12.1279 8.24834C12.1537 8.30343 12.1785 8.33151 12.2291 8.38659C12.2549 8.41468 12.3055 8.46976 12.3303 8.49677C12.3809 8.52485 12.4067 8.55185 12.4573 8.57994C12.5079 8.60802 12.5585 8.60802 12.6101 8.63502C12.6607 8.63502 12.7113 8.66311 12.7629 8.66311C12.9663 8.66311 13.1439 8.57994 13.2967 8.41468C13.3225 8.38659 13.3731 8.33151 13.3979 8.27642C13.4237 8.22134 13.4485 8.19325 13.4743 8.13817C13.5001 8.08308 13.5001 8.02799 13.5249 7.97183C13.5249 7.91674 13.5507 7.86166 13.5507 7.80549C13.5497 7.72232 13.5497 7.66724 13.5239 7.61107ZM10.4005 5.17864C10.0959 5.51023 10.0959 6.00817 10.4005 6.33976C10.5533 6.5061 10.7309 6.58819 10.9343 6.58819C11.1377 6.58819 11.3153 6.50502 11.4681 6.33976C11.7727 6.00817 11.7727 5.51023 11.4681 5.17864C11.1873 4.84597 10.7051 4.84597 10.4005 5.17864ZM8.54613 3.15989C8.24154 3.49148 8.24154 3.98942 8.54613 4.32101C8.69892 4.48735 8.87653 4.56944 9.07993 4.56944C9.28332 4.56944 9.46092 4.48627 9.61372 4.32101C9.91831 3.98942 9.91831 3.49148 9.61372 3.15989C9.30814 2.8283 8.85072 2.8283 8.54613 3.15989ZM7.63134 1.03098C7.58074 1.0029 7.55494 0.975897 7.50434 0.947814C7.45374 0.919732 7.40314 0.919732 7.35155 0.892728C7.09755 0.837642 6.84356 0.92081 6.66597 1.11415C6.51317 1.28049 6.43777 1.47384 6.43777 1.69527C6.43777 1.75035 6.43777 1.80544 6.46356 1.8616C6.46356 1.91669 6.48936 1.97178 6.51416 2.02794C6.53996 2.08303 6.56476 2.11111 6.59056 2.1662C6.61635 2.22128 6.64116 2.24936 6.69176 2.27637C6.84456 2.44271 7.02216 2.5248 7.22556 2.5248C7.42895 2.5248 7.60655 2.44163 7.75935 2.27637C7.91215 2.11003 7.98755 1.91668 7.98755 1.69526C7.98755 1.47383 7.91116 1.28049 7.75935 1.11414C7.73356 1.08606 7.68194 1.05799 7.63134 1.03098ZM3.97424 6.94775C3.56744 6.94775 3.21226 7.30744 3.21226 7.77728C3.21226 8.22014 3.54265 8.60681 3.97424 8.60681C4.38104 8.60681 4.73623 8.24713 4.73623 7.77728C4.73623 7.33442 4.40583 6.94775 3.97424 6.94775ZM7.25027 7.77728C7.25027 7.33442 6.91988 6.94775 6.48829 6.94775C6.08149 6.94775 5.7263 7.30744 5.7263 7.77728C5.7263 8.22014 6.0567 8.60681 6.48829 8.60681C6.89509 8.60681 7.25027 8.22014 7.25027 7.77728ZM9.00342 8.60681C9.41022 8.60681 9.76541 8.24713 9.76541 7.77728C9.76541 7.33442 9.43501 6.94775 9.00342 6.94775C8.59662 6.94775 8.24144 7.30744 8.24144 7.77728C8.24144 8.22014 8.57084 8.60681 9.00342 8.60681ZM1.45901 6.94775C1.05221 6.94775 0.697021 7.30744 0.697021 7.77728C0.697021 8.22014 1.02742 8.60681 1.45901 8.60681C1.86581 8.60681 2.22099 8.24713 2.22099 7.77728C2.22099 7.33442 1.89159 6.94775 1.45901 6.94775Z"
                        fill="#F15845"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
            <div className="inline-block whitespace-nowrap w-[calc(100%-136px)] overflow-x-auto ms-4">
              {timeSummary &&
                timeSummary.map((t: any) => (
                  <div
                    className="inline-block h-[120px] w-[258px] shadow-400 border border-gray-1200 rounded-md mb-5 mt-2.5 overflow-hidden me-4 cursor-pointer"
                    onClick={() => handleView(t?.id)}
                  >
                    <div className="h-[54px] w-full flex justify-start items-center ps-3 pe-2.5 bg-white rounded-t-md overflow-hidden">
                      <div className="flex justify-start items-center gap-3">
                        <div>
                          {t?.myProfile?.profilePic ? (
                            <UserImage
                              imgKey={t?.myProfile?.profilePic}
                              className="w-9 h-9 rounded-full object-cover"
                            />
                          ) : (
                            <img
                              src={getInitialsInName(
                                t?.myProfile?.name ?? "N A",
                                24
                              )}
                              alt={t?.myProfile?.name}
                              className="w-9 h-9 rounded-full object-cover"
                            />
                          )}
                        </div>
                        <div>
                          <div className="text-200 text-gray-300 font-bold">
                            {t?.myProfile?.name}
                          </div>
                          <div className="text-100 text-gray-700 font-normal">
                            {t?.myProfile?.designation} | {t?.myProfile?.team}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="h-[calc(100%-54px)] bg-gray-200 flex justify-between items-center ps-3 pe-2.5">
                      <div>
                        <div className="text-600 text-gray-300 font-bold flex justify-start items-center">
                          {getDayAndMonth(t?.startDate).day}{" "}
                          <span className="text-200 font-light ms-0.5">
                            {getDayAndMonth(t?.startDate).month}
                          </span>
                          <span className="font-light mx-1">-</span>
                          {getDayAndMonth(t?.endDate).day}
                          <span className="text-200 font-light ms-0.5">
                            {getDayAndMonth(t?.endDate).month}
                          </span>
                        </div>
                        {/* <div
                          className={`flex justify-center items-center px-2 py-1 gap-2 text-100 font-normal bg-green-100 rounded-full text-white ${
                            t?.isApproved === true
                              ? "bg-green-100"
                              : "bg-pastel-900"
                          }`}
                        > */}
                        <ColorLabel text={t?.leave?.leaveCode === "RH" ? "Holiday" : t?.leave?.title} className="!h-auto !w-auto !text-100 !font-normal !px-2.5 !py-1 !rounded-2xl text-white">
                          <span>{t?.leave?.title}</span>{" "}
                          <span className="font-bold">
                            {/* {t?.requestFor.toFixed(2)}d */}
                            {t?.requestFor}d
                          </span>
                        {/* </div> */}
                        </ColorLabel>
                      </div>
                      {t?.isApproved === null && (
                        <div className="flex justify-start items-center text-200 text-gray-500 bg-gray-100 font-normal capitalize py-1 px-3 rounded-full">
                          <span className="me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="12"
                              viewBox="0 0 14 12"
                              fill="none"
                            >
                              <path
                                d="M13.9854 10.9391C13.968 10.7427 13.8995 10.5385 13.7799 10.3318L8.19573 0.659579C8.07679 0.452924 7.93443 0.291344 7.77283 0.177805C7.60584 0.061266 7.419 0 7.23279 0C7.04657 0 6.85974 0.0612737 6.69274 0.177805C6.53115 0.290741 6.38877 0.45294 6.26984 0.659579L0.685025 10.3318C0.566082 10.5385 0.496993 10.7427 0.479585 10.9391C0.462164 11.1416 0.501811 11.3344 0.595524 11.496C0.688636 11.6576 0.835212 11.7885 1.01963 11.8744C1.19805 11.9579 1.4095 12 1.64797 12H12.8165C13.055 12 13.2665 11.9579 13.4449 11.8744C13.6293 11.7885 13.7759 11.6576 13.869 11.496C13.9633 11.3344 14.0034 11.1416 13.9854 10.9391ZM7.23273 10.2573C6.85728 10.2573 6.55271 9.95275 6.55271 9.5773C6.55271 9.20185 6.85728 8.89789 7.23273 8.89789C7.60817 8.89789 7.91274 9.20185 7.91274 9.5773C7.91274 9.95275 7.60817 10.2573 7.23273 10.2573ZM8.0497 4.20331L7.83164 7.80401C7.81902 8.02026 7.63039 8.19748 7.41353 8.19748H7.05069C6.83383 8.19748 6.64581 8.02027 6.63258 7.80401L6.41452 4.20331C6.4013 3.98706 6.5677 3.80984 6.78455 3.80984H7.67782C7.89589 3.81044 8.06291 3.98705 8.0497 4.20331Z"
                                fill="#B2B2B2"
                              />
                            </svg>
                          </span>
                          Pending
                        </div>
                      )}
                      {t?.isApproved === true && (
                        <div className="flex justify-start items-center text-[8px] text-green-100 bg-green-100 bg-opacity-10 font-normal uppercase py-1 px-3 rounded-full">
                          <span className="me-1">
                            <svg
                              width="13"
                              height="13"
                              viewBox="0 0 13 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.56763 12.6872C9.86763 12.6872 12.5676 9.9872 12.5676 6.68719C12.5676 3.38719 9.86763 0.687195 6.56763 0.687195C3.26763 0.687195 0.567627 3.38719 0.567627 6.68719C0.567627 9.9872 3.26763 12.6872 6.56763 12.6872Z"
                                fill="#2EB67D"
                              />
                              <path
                                d="M4.01782 6.68726L5.71582 8.38526L9.11782 4.98926"
                                fill="#2EB67D"
                              />
                              <path
                                d="M4.01782 6.68726L5.71582 8.38526L9.11782 4.98926"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                          Approved
                        </div>
                      )}
                      {t?.isApproved === false && (
                        <div className="flex justify-start items-center text-[8px] uppercase font-normal text-primary-100 py-1 px-2.5 rounded-full bg-primary-100 bg-opacity-10">
                          <span className="me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="16"
                              viewBox="0 0 14 16"
                              fill="none"
                            >
                              <path
                                d="M7 0.5C10.866 0.5 14 3.8579 14 8C14 12.1421 10.866 15.5 7 15.5C3.13404 15.5 0 12.1421 0 8C0 3.8579 3.13404 0.5 7 0.5ZM3.45698 10.2107C3.04833 10.6485 3.04833 11.3584 3.45698 11.7961C3.86564 12.2339 4.52819 12.2339 4.93668 11.7961L7 9.58539L9.06332 11.7961C9.47198 12.2339 10.1345 12.2339 10.543 11.7961C10.9517 11.3582 10.9517 10.6484 10.543 10.2107L8.47969 8L10.543 5.7893C10.9517 5.35145 10.9517 4.64158 10.543 4.20391C10.1344 3.76607 9.47182 3.76607 9.06332 4.20391L7 6.41461L4.93668 4.20391C4.52802 3.76607 3.86548 3.76607 3.45698 4.20391C3.04833 4.64175 3.04833 5.35163 3.45698 5.7893L5.52031 8L3.45698 10.2107Z"
                                fill="#F15845"
                              />
                            </svg>
                          </span>
                          DENIED
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="min-h-[calc(100vh-480px)] w-full">
        <div className="px-10 pt-4">
          <div className="grid grid-cols-2 gap-7">
            <div>
              <div className="flex justify-start items-center">
                <Typography variant="h6" className="text-gray-300 font-bold">
                  Time Off Status
                </Typography>
              </div>

              <div
                className="border border-gray-100 rounded-md mt-4 bg-white p-5 pt-0 h-[31.188rem] overflow-auto relative"
                style={{
                  boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.05)",
                }}
              >
                {timeHistory && timeHistory.length > 0 ? (
                  <>
                    <div className="pt-4 pb-2 bg-white sticky left-0 top-0 z-10 w-full h-auto flex justify-end">
                      <button
                        className="text-gray-700 text-100 font-medium opacity-70"
                        onClick={() => handleTimeOff("tab1")}
                      >
                        View All
                      </button>
                    </div>

                    {timeHistory.map((t: any) => (
                      <div key={`${t.year}-${t.month}`}>
                        <div className="flex justify-between items-center mt-2">
                          <div className="text-200 text-gray-300 font-bold">
                            {getMonthName(t?.month)} {t?.year}
                          </div>
                        </div>
                        <div>
                          {t.details &&
                            t.details.map((item: any) => (
                              <div
                                key={item.id}
                                className="flex justify-start items-center py-3 border-b border-black border-opacity-10 gap-2"
                              >
                                <div className="w-[50%] flex justify-start items-center gap-3">
                                  <div>
                                    {item.myProfile?.profilePic ? (
                                      <UserImage
                                        imgKey={item?.myProfile?.profilePic}
                                        className="w-9 h-9 rounded-full object-cover"
                                      />
                                    ) : (
                                      <img
                                        src={getInitialsInName(
                                          item?.myProfile?.name ?? "N A",
                                          24
                                        )}
                                        alt={item?.myProfile?.name}
                                        className="w-9 h-9 rounded-full object-cover"
                                      />
                                    )}
                                  </div>
                                  <div>
                                    <div className="text-200 text-gray-300 font-bold line-clamp-1">
                                      {item?.myProfile?.name}
                                    </div>
                                    <div className="text-100 text-gray-700 font-normal line-clamp-1">
                                      {item?.myProfile?.designation} |{" "}
                                      {item?.myProfile?.team}
                                    </div>
                                  </div>
                                </div>
                                <div className="w-[20%]">
                                  <div className="text-200 text-gray-300 font-bold line-clamp-1">
                                    {item?.requestFor}d
                                  </div>
                                  <div className="text-100 text-gray-700 font-normal">
                                    {getDayAndMonth(item?.startDate).month}{" "}
                                    {getDayAndMonth(item?.startDate).day} -{" "}
                                    {getDayAndMonth(item?.endDate).month}{" "}
                                    {getDayAndMonth(item?.endDate).day}
                                  </div>
                                </div>

                                <div className="w-[30%] flex justify-between items-center">
                                <ColorLabel text={item?.leave?.leaveCode === "RH" ? "Holiday" : item?.leave?.title} className="!h-auto !w-auto !text-100 !font-normal !px-2.5 !py-1 !rounded-2xl text-white">
                                  {/* <div className="bg-green-100 text-100 font-normal px-2.5 py-1 rounded-full text-white"> */}
                                    {item?.leave?.title}
                                  {/* </div> */}
                                  </ColorLabel>
                                  {role?.roleName === "Admin" && (
                                    <div>
                                      <div className="text-100 text-gray-700 font-bold">
                                        {item?.isLeaveCancelled
                                          ? "Cancelled"
                                          : item?.isApproved === null
                                          ? "Pending"
                                          : item?.isApproved
                                          ? "Approved"
                                          : "Denied"}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  // <div className="h-[calc(100%-2.5rem)]">
                    <LeaveBalanceEmpty team={"team"}/>
                  // </div>
                )}
              </div>
            </div>
            <div className="">
              <div className="h-full w-full flex flex-col grow">
                <Typography variant="h6" className="text-gray-300 font-bold">
                  Time Off Calendar
                </Typography>
                <div
                  className="border border-gray-100 rounded-md mt-4 bg-white rounded-b-md grow flex flex-col h-[31.188rem]"
                  style={{
                    boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  {/* {calenderDetail ? ( */}
                    <CalenderSlider
                      setStartMonthTeam={setStartMonthTeam}
                      setEndMonthTeam={setEndMonthTeam}
                      setSelectedDate={setSelectedDate}
                      calenderDetail={calenderDetail}
                      fyStartDate={fyStartDate}
                      fyEndDate={fyEndDate}
                      setCurrentSlideTeam={setCurrentSlideTeam}
                      currentSlideTeam={currentSlideTeam}
                      setCurrent={setCurrent}
                      current={current}
                      selectedDate={selectedDate}
                    />
                  {/* ) : (
                    <TimeOffCalenderEmpty />
                  )} */}

                  <div className="border-t border-black border-opacity-10 pt-5 bg-gray-400 rounded-b-md grow flex flex-col overflow-auto">
                    <div className="flex justify-between items-center px-5">
                      <div className="text-200 text-gray-300 font-nomal opacity-70">
                        Employees on Time Off
                      </div>
                      <button
                        className="text-200 text-gray-300 font-nomal opacity-70"
                        onClick={() => handleTimeOff("tab2")}
                      >
                        View all upcoming leaves
                      </button>
                    </div>

                    <div className="h-[9.5rem] overflow-auto px-5">
                      {calenderDate?.length > 0 ? (
                        calenderDate?.map((t: any) => (
                          <div className="">
                            <div className="flex justify-start items-center py-3 border-b border-black border-opacity-10">
                              <div className="w-[50%] flex justify-start items-center gap-3">
                                <div>
                                  {t.myProfile?.profilePic ? (
                                    <UserImage
                                      imgKey={t?.myProfile?.profilePic}
                                      className="w-9 h-9 rounded-full object-cover"
                                    />
                                  ) : (
                                    <img
                                      src={getInitialsInName(
                                        t?.myProfile?.name ?? "N A",
                                        24
                                      )}
                                      alt={t?.myProfile?.name}
                                      className="w-9 h-9 rounded-full object-cover"
                                    />
                                  )}
                                </div>
                                <div>
                                  <div className="text-200 text-gray-300 font-bold">
                                    {t?.myProfile?.name}
                                  </div>
                                  <div className="text-100 text-gray-700 font-normal">
                                    {t?.myProfile?.designation} |{" "}
                                    {t?.myProfile?.team}
                                  </div>
                                </div>
                              </div>
                              <div className="w-[25%]">
                                <div className="text-200 text-gray-300 font-semibold">
                                  {getDayAndMonth(t?.startDate).month}{" "}
                                  {getDayAndMonth(t?.startDate).day} -{" "}
                                  {getDayAndMonth(t?.endDate).month}{" "}
                                  {getDayAndMonth(t?.endDate).day}
                                </div>
                              </div>
                              <div className="w-[25%] flex justify-end items-center">
                              <ColorLabel text={t?.leave?.title} className="!h-auto !w-auto !text-100 !font-normal !px-2.5 !py-1 !rounded-2xl text-white">
                                {/* <div className="bg-green-100 text-100 font-normal px-2.5 py-1 rounded-full text-white"> */}
                                  {t?.leave?.title}
                                  <span className="ms-1.5 font-bold">
                                    {t?.requestFor}d
                                  </span>
                                {/* </div> */}
                                </ColorLabel>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="flex justify-center items-center text-center h-[9.375rem]">
                          <div className="">
                            <div className="flex justify-center">
                              <img
                                src={emptyTimeOffImage}
                                alt={emptyTimeOffImage}
                              />
                            </div>
                            <div className="text-gray-700 text-400 font-normal mt-2.5">
                            Team time off data for the two<br></br> months
                              will be shown here.
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {timeOffHistory && (
                    <TimeOffHistoryModal
                      onClose={() => setTimeOffHistory(false)}
                    />
                  )}
                  {singleTimeOffHistory && (
                    <SingleTimeOffHistoryModal
                      onClose={() => setSingleTimeOffHistory(false)}
                    />
                  )}
                  {teamTimeOffHistory && (
                    <TeamTimeOffHistoryModal
                      onClose={() => setTeamTimeOffHistory(false)}
                      setSelectedValue={setSelectedValue}
                      selectedValue={selectedValue}
                      setSearchString={setSearchString}
                      searchString={searchString}
                    />
                  )}
                  {upcomingLeaves && (
                    <UpcomingLeavesModal
                      onClose={() => setUpcomingLeaves(false)}
                      setSelectedValue={setSelectedValue}
                      selectedValue={selectedValue}
                      timeoffTab={timeoffTab}
                    />
                  )}
                  {rmCreateTimeOff && (
                    <RequestTimeOffModal
                      onClose={() => setRmCreateTimeOff(false)}
                      financialyearList={financialyearList}
                      setRequestTimeOff={setRmCreateTimeOff}
                      getSummary={getSummary}
                      type={type}
                      tab={tab}
                    />
                  )}
                  {timeOffDetailsBoth && (
                    <TimeOffDetailsBothModal
                      onClose={() => setTimeOffDetailsBoth(false)}
                      timeoffId={timeoffId}
                      setTimeOffDetailsBoth={setTimeOffDetailsBoth}
                      getSummary={getSummary}
                      getTimeoffList={getTimeoffList}
                      type={type}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTeamTimeOff;
